// extracted by mini-css-extract-plugin
module.exports =  {"label":"label_kDdYmsYz","sublabel":"sublabel_KMn8ktfB"};